import { VibeLoginModal } from './components/auth/VibeLoginModal';
import { AuthRouteGate } from './components/auth/AuthRouteGate';
import { CollapsibleSidebarOverlay } from './components/overlays/CollapsibleSidebarOverlay';
import { HomeChatMorphOverlay } from './components/overlays/HomeChatMorphOverlay';
import { HomePromptOverlay } from './components/overlays/HomePromptOverlay';
import { StudioCommandPalette } from './components/overlays/StudioCommandPalette';
import { OnboardingPanelsBridgeMount } from './hooks/useOnboardingPanelsBridge';
import { SitePanelsBridgeMount } from './hooks/useSitePanelsBridge';
import { DraftPreviewBridge } from './components/session/DraftPreviewBridge';
import { SessionStatusChip } from './components/session/SessionStatusChip';
import { SiteActionsBridge } from './components/session/SiteActionsBridge';
import { SiteContextToolbarBridge } from './components/session/SiteContextToolbarBridge';
import { FileManagerBridge } from './components/session/FileManagerBridge';
import { CanvasHost } from './CanvasHost';
import { AuthProvider } from './contexts/AuthContext';
import { CanvasSessionProvider } from './contexts/CanvasSessionContext';
import { UiOverlayProvider } from './contexts/UiOverlayContext';
import { useUiOverlay } from './contexts/useUiOverlay';
import { useAgUiBridge } from './hooks/useAgUiBridge';
import { useCanvasActionsBridge } from './hooks/useCanvasActionsBridge';
import { useCanvasStatePersistence } from './hooks/useCanvasStatePersistence';
import { useEditIntentListener } from './hooks/useEditIntentListener';
import { useGenerationIntentListener } from './hooks/useGenerationIntentListener';
import { usePendingGenerationResume } from './hooks/usePendingGenerationResume';
import { useSessionHomeSync } from './hooks/useSessionHomeSync';
import { AppThemeProvider } from './providers/AppThemeProvider';

function SessionSpineMount(): null {
  useGenerationIntentListener();
  usePendingGenerationResume();
  useEditIntentListener();
  useCanvasActionsBridge();
  useAgUiBridge();
  useCanvasStatePersistence();
  return null;
}

function SessionUiSyncMount(): null {
  useSessionHomeSync();
  return null;
}

function AppShell(): React.JSX.Element {
  const { homeVisible } = useUiOverlay();

  return (
    <div className={`app-shell${homeVisible ? ' app-shell--home' : ''}`}>
      {!homeVisible ? <CanvasHost /> : null}
      <div className="overlay-root">
        <CollapsibleSidebarOverlay />
        <HomePromptOverlay />
        <HomeChatMorphOverlay />
        <SessionStatusChip />
        <SiteActionsBridge />
        <StudioCommandPalette />
      </div>
      <SessionSpineMount />
      <SiteContextToolbarBridge />
      <OnboardingPanelsBridgeMount />
      <SitePanelsBridgeMount />
      <DraftPreviewBridge />
      <FileManagerBridge />
      <VibeLoginModal />
    </div>
  );
}

export function App(): React.JSX.Element {
  return (
    <AppThemeProvider>
      <AuthProvider>
        <AuthRouteGate>
          <CanvasSessionProvider>
            <UiOverlayProvider>
              <AppShell />
              <SessionUiSyncMount />
            </UiOverlayProvider>
          </CanvasSessionProvider>
        </AuthRouteGate>
      </AuthProvider>
    </AppThemeProvider>
  );
}
